import { useEffect } from '../../../src/InBuildImports';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Properties, systemConfiguration, includeScripts, includeBootstrapCss, includeBundleBootstrapCss} from '../../../src/CommonImports';
import './../css/GSideBar.css';
import './../css/Gtop.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import './../css/GLayOutSpacing.css';
import './../css/GAnimetion.css';
import './../css/GAboutUs.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function GJobAboutFindJob() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    useEffect(() => {
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                sidebar.show();
            }
        });
    }, []);


    return (
        <div>
        <section className="section-box mt-50 mb-80">
            <div className="container">
                <div className="block-job-bg block-job-bg-homepage-2">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12 d-none d-md-block">
                            <div className="box-image-findjob findjob-homepage-2 ml-0 wow animate__ animate__fadeIn animated" style={{visibility:"visible",animationName:"fadeInUp"}}>
                                <figure><img alt="jobhub" src={mediaUrl+"img-findjob.png?"+sasToken}/></figure>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="box-info-job pl-90 pt-30 pr-90">
                                <span className="text-blue wow animate__ animate__fadeInUp animated" style={{visibility:"visible",animationName:"fadeInUp"}}>Find jobs</span>
                                <h5 className="heading-36 mb-30 mt-30 wow animate__ animate__fadeInUp animated" style={{visibility:"visible",animationName:"fadeInUp"}}>Create free count and start apply your dream job today</h5>
                                <p className="text-lg wow animate__ animate__fadeInUp animated" style={{visibility:"visible",animationName:"fadeInUp"}}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is
                                    simply dummy.
                                </p>
                                <div className="mt-30 wow animate__ animate__fadeInUp animated" style={{visibility:"visible",animationName:"fadeInUp"}}>
                                    <a href="job-grid.html" className="btn btn-default">Explore more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="section-box mt-90 mt-md-0">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-12 col-sm-12 col-12">
                        <span className="text-lg text-brand wow animate__ animate__fadeInUp animated" style={{visibility:"visible",animationName:"fadeInUp"}}>Online Marketing</span>
                        <h3 className="mt-20 mb-30 wow animate__ animate__fadeInUp animated" style={{visibility:"visible",animationName:"fadeInUp"}}>Committed to top quality and results</h3>
                        <p className="mb-20 wow animate__ animate__fadeInUp animated" style={{visibility:"visible",animationName:"fadeInUp"}}>Proin ullamcorper pretium orci. Donec necscele risque leo. Nam massa dolor imperdiet neccon sequata congue idsem. Maecenas malesuada faucibus finibus. </p>
                        <p className="mb-30 wow animate__ animate__fadeInUp animated" style={{visibility:"visible",animationName:"fadeInUp"}}>Proin ullamcorper pretium orci. Donec necscele risque leo. Nam massa dolor imperdiet neccon sequata congue idsem. Maecenas malesuada faucibus finibus. </p>
                        <div className="mt-10 wow animate__ animate__fadeInUp animated" style={{visibility:"visible",animationName:"fadeInUp"}}>
                            <a href="#" className="btn btn-default">Learn more</a>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-sm-12 col-12 pl-200 d-none d-lg-block">
                        <div className="banner-imgs banner-imgs-about">
                            <img alt="jobhub" src={mediaUrl+"banner-online-marketing.png?"+sasToken} className="img-responsive main-banner shape-3"/>
                            <span className="banner-sm-4"><img alt="jobhub" src={mediaUrl+"congratulation.svg?"+sasToken} className="img-responsive shape-2"/></span>
                            <span className="banner-sm-5"><img alt="jobhub" src={mediaUrl+"web-dev.svg?"+sasToken} className="img-responsive shape-1"/></span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>
    );
}
export default GJobAboutFindJob;